'use client';
import { useState, useEffect, useContext } from 'react';
import { Container, Modal } from 'react-bootstrap';
import './ScheduleDemo.scss';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Calendar from 'react-calendar';
import moment from 'moment-timezone';
import { Slots } from '@/features/availability/components/Slot';
import { useNavigate, useParams } from 'react-router-dom';
import { useBusiness } from '@/features/availability/api/getBisiness';
import appCompoLoading from '@/assets/animation/loading.json';

import Logo from '@/assets/img/logo-v2.svg';
import Bouquet from '@/assets/img/boquet.png';
import DateIcon from '@/assets/img/day-icon.png';
import DateIconGrey from '@/assets/img/date-icon-gray.svg';

import TimeIcon from '@/assets/img/time-icon.png';
import MeetingTimeIcon from '@/assets/img/time-icon.svg';
import MeetingIcon from '@/assets/img/meeting-icon.svg';
import GlobeIcon from '@/assets/img/user-icon.svg';
import UserIcon from '@/assets/img/v2/user-default-icon.png';

import BackIcon from '@/assets/img/back-icon.svg';
import { CalendarUsers, DemoUser, Slot } from '../types';
import { showNotification } from '@/utils/notificationUtils';
import Utils from '@/utils/util';
import { useGetAvailabilities } from '../api/getAvailability';
import { WEBSITE_URL } from '@/config';
import { useScheduleDemo, useScheduleDemoSlot } from '../api/bookAppointment';
import Lottie from 'lottie-react';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { UserContext } from '@/components/Layout';

export default function ScheduleDemo() {
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const { slug } = useParams();
  const useGetAvailabilitiesMutation = useGetAvailabilities();
  const useScheduleDemoMutation = useScheduleDemo();
  const useScheduleSlotDemoMutation = useScheduleDemoSlot();
  const businessQuery = useBusiness({ slugName: slug });
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [userData, setUserData] = useState<DemoUser>({
    name: '',
    email: '',
    phone: '',
    storeName: '',
    zipCode: '',
    address: '',
    businessUserId: '',
    summary: 'Petsked demo',
    description: 'Petsked demo',
  });
  const [showNextPage, setShowNextPage] = useState(false);
  const [hostBusinessData, setHostBusinessData] = useState<CalendarUsers>();
  const [businessTz, setBusinessTz] = useState<string>();
  const [availability, setAvailability] = useState<any>(null);
  const [slots, setSlots] = useState<Slot[]>();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState<Slot>();
  const [demoId, setDemoId] = useState<string>();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [googleMeetLink, setGoogleMeetLink] = useState<string>();
  useEffect(() => {
    if (businessQuery.data) {
      setHostBusinessData(
        businessQuery?.data?.businessUsers && businessQuery?.data?.businessUsers[0]
      );
      setBusinessTz(businessQuery?.data.timezone);
    }
  }, [businessQuery.data]);
  useEffect(() => {
    if (hostBusinessData) {
      getAvailabilitySlots();
    }
  }, [hostBusinessData]);

  useEffect(() => {
    const slots: Slot[] = [];
    if (availability) {
      availability.map((item: Slot, index: number) => {
        let formatedDate;

        if (businessTz) {
          formatedDate = moment(item.start).tz(businessTz).format('hh:mm A');
        } else {
          formatedDate = moment(item.start).format('hh:mm A');
        }
        if (formatedDate.indexOf('PM') > 0) {
          slots.push({ ...item, label: formatedDate, id: index });
        } else {
          slots.push({ ...item, label: formatedDate, id: index });
        }
      });
    }
    setSlots(slots);
  }, [availability]);

  const getAvailabilitySlots = async (date?: Date) => {
    const selectedNewDate = date ? date : new Date();

    if (hostBusinessData) {
      const res = await useGetAvailabilitiesMutation.mutateAsync({
        data: {
          businessId: Number(hostBusinessData?.businessId),
          duration: 30,
          date: Utils.toServerTz(selectedNewDate, businessTz), //"2022-11-21T00:00:00+05:30"
          tz: moment.tz.guess(true),
          serviceType: Utils.SERVICE_TYPES.GROOMING
        },
        headers: {
          'loc-id': hostBusinessData?.LocationUserModel?.businessLocationId,
        },
      });
      setAvailability(res);
    }
  };
  const saveUserData = async () => {
    const isFormValid = validate();
    if (isFormValid) {
      const { name, email, phone, storeName, zipCode, summary, description, address } = userData;
      const res = await useScheduleDemoMutation.mutateAsync({
        data: {
          name,
          email: email.toLowerCase(),
          phone,
          storeName,
          address,
          zipCode,
          description,
          summary,
          businessUserId: hostBusinessData?.id,
        },
        headers: {
          'loc-id': hostBusinessData?.LocationUserModel?.businessLocationId,
        },
      });
     
      if (res) {
        setDemoId(res.id);
        setShowNextPage(true);
      }
    }
  };
  const validate = () => {
    const { name, email, phone, storeName, address, zipCode } = userData;
    let errorMessage;
    if (!name || name.trim().length < 1) {
      errorMessage = 'Please enter valid full name';
    } else if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      errorMessage = 'please enter valid email';
    } else if (!phone || phone.trim().length < 1) {
      errorMessage = 'Please enter valid phone number';
    } else if (!storeName || storeName.trim().length < 1) {
      errorMessage = 'Please enter valid store name';
    } else if (!address || address.trim().length < 1) {
      errorMessage = 'Please enter valid address';
    } else if (!zipCode || zipCode.trim().length < 1) {
      errorMessage = 'Please enter valid zip code';
    }
    if (errorMessage) {
      showNotification({
        type: 'info',
        title: errorMessage,
      });
      return false;
    }
    return true;
  };
  const scheduleDemo = async () => {
    if (selectedSlot) {
      const res = await useScheduleSlotDemoMutation.mutateAsync({
        data: { startTime: selectedSlot.start, duration: 30, id: demoId },
        headers: {
          'loc-id': hostBusinessData?.LocationUserModel?.businessLocationId,
          tz,
        },
      });
      if (res) {
        setGoogleMeetLink(res.googleMeetLink);
        //setShowConfirmationModal(true);
       
        backToPreviousPage(false);
        const urlParams = extractUrlParams();
        userContext?.updateDemoConfirmationData({
          selectedSlot,
          googleMeetLink: res.googleMeetLink,
          hostBusinessData,
          email: userData.email,
          urlParams
        })
        setUserData({
          name: '',
          email: '',
          phone: '1',
          storeName: '',
          zipCode: '',
          address: '',
          businessUserId: '',
          summary: 'Petsked demo',
          description: 'Petsked demo',
        });
        navigate(`/${slug}/demo-thankyou`)
      }
    } else {
      showNotification({
        type: 'info',
        title: 'Please select the time slot',
      });
    }
  };
  const onSlotSelected = (data: any) => {
    setSelectedSlot(data);
  };
  const extractUrlParams = (extend = false) => {
    const urlParams = new URLSearchParams(window.location.search);
    const params: any = {};
    urlParams.forEach((value, key) => {
      params[key] = value;
    });
    params.referrer_url = document.referrer;
    return params;
  };

  const onFormValueChange = (formFieldName: string, value: string) => {
    const data: any = userData;
    if (userData) {
      data[formFieldName] = value;
    }
    setUserData({ ...data });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    // Regular expression to allow only numbers
    const regex = /^[0-9\b]+$/;
    if (inputValue === '' || regex.test(inputValue)) {
      const data: any = userData;
      if (userData) {
        data['zipCode'] = inputValue;
      }
      setUserData({ ...data });
    }
  };
  const onDateChange = (date: any) => {
    setSelectedDate(date);
    setSelectedSlot(undefined);
    getAvailabilitySlots(date);
  };
  const backToWebsite = () => {
    if (showNextPage) {
      backToPreviousPage(true);
    } else {
      window.open(WEBSITE_URL, '_self');
    }
  };

  const backToPreviousPage = (reset = true) => {
    if (reset) {
      setSelectedSlot(undefined);
    }
    setShowNextPage(false);
    getAvailabilitySlots();
  };
  const onHideConfirmationModal = () => {
    setShowConfirmationModal(false);
    setSelectedSlot(undefined);
  };
  const slotLabel = selectedSlot?.label ? `(${selectedSlot?.label})` : '';
  return (
    <>
      <div className="back-nav-schedule" onClick={backToWebsite}>
        <img src={BackIcon} alt="back icon" />
        <span>Back</span>
      </div>
      <section className="petsked-container-no-bg  petsked-schedule-demo">
        <div className="content">
          <div>
            <div className="schedule-step-1">
              <div className="back-nav" onClick={backToWebsite}>
                <img src={BackIcon} alt="back icon" />
                <span>Back</span>
              </div>
              <PetskedTitle title="Schedule a" highlightTitle="product demo" size="lg" />
              <p className="desc"></p>
              <div className="details">
                <div className="meeting-details">
                  <span>
                    {/* {hostBusinessData && (
                    <img
                      className="user-icon"
                      src={hostBusinessData?.avatarUrl ? hostBusinessData?.avatarUrl : UserIcon}
                      alt="user icon"
                    />
                  )}
                  <p className="host-name">{hostBusinessData?.name}</p> */}
                    <p className="desc">
                      Schedule a product walkthrough with our dedicated executive for a depth
                      exploration of its features and benefits.
                    </p>
                  </span>

                  <div className="extra">
                    {showNextPage && selectedSlot && (
                      <span>
                        <img src={DateIconGrey} />{' '}
                        {Utils.getOnlyDate(selectedSlot?.start, businessTz, 'dddd, MMMM DD, YYYY')}{' '}
                        {Utils.getOnlyDate(selectedSlot?.start, businessTz, 'hh:mm A')}
                      </span>
                    )}
                    <span>
                      <img src={MeetingTimeIcon} /> 30 mins
                    </span>
                    {/* <span>
                    <img src={MeetingIcon} /> Link meeting
                  </span> */}

                    <span>
                      <img src={GlobeIcon} />
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>{Utils.getDetailedTz(businessTz)}</span>
                    </span>
                  </div>
                </div>
                {!showNextPage ? (
                  <div className="user-registration-form">
                    <div className="petsked-form">
                      <label>Personal Information</label>
                      <input
                        className="fn"
                        type="text"
                        value={userData?.name}
                        placeholder="Full name"
                        onInput={(e: any) => onFormValueChange('name', e.target?.value)}
                      />
                      <div className="split">
                        <input
                          type="email"
                          value={userData?.email}
                          placeholder="Email address"
                          onInput={(e: any) => onFormValueChange('email', e.target?.value)}
                        />
                        <PhoneInput
                          country={'us'}
                          value={userData?.phone}
                          onChange={(data: any) => onFormValueChange('phone', data)}
                          placeholder='Phone number'
                          countryCodeEditable={false}
                        />
                      </div>
                      <hr />
                      <label>Business Information</label>
                      <input
                        className="fn"
                        type="text"
                        value={userData?.storeName}
                        placeholder="Business name"
                        onInput={(e: any) => onFormValueChange('storeName', e.target?.value)}
                        maxLength={50}
                      />
                      <div className="split">
                        <input
                          type="text"
                          value={userData?.address}
                          placeholder="Address"
                          onInput={(e: any) => onFormValueChange('address', e.target?.value)}
                        />
                        <input
                          type="phone"
                          value={userData?.zipCode}
                          placeholder="Zip code"
                          maxLength={10}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="action">
                        <button className="petsked-btn dark" onClick={() => saveUserData()}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="slot-selection">
                    <div className="schedule-step-2">
                      <Calendar value={selectedDate} minDate={Utils.fromServerTz(new Date(), businessTz)} onChange={onDateChange} />
                      <div>
                        <p className="selected-date">
                          {Utils.getOnlyDate(selectedDate, 'dddd, DD MMM')}
                        </p>
                        <Slots
                          title="am slots"
                          slots={slots}
                          onSelectSlot={onSlotSelected}
                          selectedSlot={selectedSlot}
                          isLoading={useGetAvailabilitiesMutation.isLoading}
                        />
                      </div>
                    </div>
                    <div className="action">
                      <button className="petsked-btn" onClick={() => backToPreviousPage(true)}>
                        Back
                      </button>
                      <button className="petsked-btn dark" onClick={scheduleDemo}>
                        Schedule
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Modal
            className="petsked-modal-dialog schedule-demo-confirmation-modal"
            show={showConfirmationModal}
            onHide={onHideConfirmationModal}
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <div className="top">
                <img src={Bouquet} />
                <h5>Appointment has been scheduled</h5>
                <p>
                  Congratulations! the appointment for product tour has been confirmed successfully.
                </p>
              </div>
              <div className="time-container">
                <div className="schedule-demo-date">
                  <p>
                    <img src={DateIcon} />

                    <span>
                      {selectedSlot && Utils.getOnlyDate(selectedSlot.start, 'MMM DD, yyyy')}
                    </span>
                  </p>
                  <p>Scheduled date</p>
                </div>
                <div className="schedule-demo-time">
                  <p>
                    <img src={TimeIcon} />
                    <span>{selectedSlot && selectedSlot.label}</span>
                  </p>
                  <p>Scheduled time</p>
                </div>
              </div>
              <div className="meeting-details">
                <div className="">
                  {googleMeetLink && (
                    <div className="detail">
                      <label>Meeting link</label>
                      <p>{googleMeetLink}</p>
                    </div>
                  )}
                  <div className="detail">
                    <label>Meeting duration</label>
                    <p>30 Minutes</p>
                  </div>
                  <div className="detail">
                    <label>Meeting host</label>
                    <div className="host-details">
                      <img
                        src={hostBusinessData?.avatarUrl ? hostBusinessData?.avatarUrl : UserIcon}
                      />
                      <div>
                        <p>{hostBusinessData?.name}</p>
                        <p>{hostBusinessData?.email}</p>
                      </div>
                    </div>
                  </div>
                  <div className="detail">
                    <label>Time zone</label>
                    <p>
                      {Utils.getTzAbbr(businessTz)} ({selectedSlot?.label})
                    </p>
                  </div>
                </div>
              </div>
              <div className="action">
                <a onClick={backToWebsite}>Continue exploring website</a>
              </div>
            </Modal.Body>
          </Modal>
        </div>
        {((showNextPage && useGetAvailabilitiesMutation.isLoading) ||
          useScheduleDemoMutation.isLoading ||
          useScheduleSlotDemoMutation.isLoading) && (
          <div className="preloader-schedule">
            {/* <div className="loader" /> */}
            <Lottie className="loader" animationData={appCompoLoading} />
          </div>
        )}
      </section>
    </>
  );
}
